import React, { useEffect, useState } from 'react';
import SuperAdminDeleteExp from './DeleteExp';
import { Container, Image, Row, Col, Table } from 'react-bootstrap';
import moment from 'moment';
import SimpleReactLightbox, { SRLWrapper } from 'simple-react-lightbox';
import { NOTAVAILABLEIMAGE } from '../../../../enums/GlobalEnums';
import { Toggle } from '../../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle';
import ViewExpDetails from './ViewExpDetails';
import { useHistory } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { errorAlert, successAlert } from '../../../../function/alert';
import { amApi } from '../../../../api/apiHelper';
import ViewExpSessions from './ViewExpSessions';
import { useSelector } from 'react-redux';
import ReadMore from '../../../reusableComponents/ReadMore';
import ShareLinkModal from '../../../reusableComponents/ShareLinkModal';
import { webappUrl } from '../../../../config/Keys';
const ExperienceBody = ({ exp, removeExp, updatePrimary, disable }) => {
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  const history = useHistory();
  const restaurantSession = useSelector((state) => {
    try {
      return state.onboarding?.restaurantDetails?.experienceManagement[
        exp?.expType?.toLowerCase() || 'special'
      ];
    } catch (err) {
      return false;
    }
  });
  const onBoarddetails = useSelector((state) => {
    try {
      return state.onboarding?.restaurantDetails;
    } catch (err) {
      return false;
    }
  });

  const onToggleChange = (type) => (e) => {
    if (restaurantSession) {
      let update = {};
      if (type === 'ACTIVE') {
        update.active = e;
      } else {
        if (e === true && !exp.active) {
          errorAlert('Activate the Experience to make Primary.');
          return;
        }
        update.primary = e;
      }
      amApi
        .patch(`/experience/${exp._id}`, update)
        .then((res) => {
          updatePrimary(exp._id, type);
          successAlert('Updated Successfully');
        })
        .catch((err) => {
          errorAlert('Something went wrong');
        });
    } else {
      errorAlert('Experience Session is Off for this restaurant');
    }
  };

  const getTheLowestPrice = (pack) => {
    if (pack?.length) {
      let lowestPrice = Math.min(
        ...pack?.map((e) =>
          e?.discountedPrice ? e?.discountedPrice : e?.price
        )
      );
      return `${lowestPrice > 0 ? `Package :${lowestPrice}/-` : ''}`;
    } else return '';
  };
  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body seating-dashboard-body-new"
      key={exp._id}
    >
      <tr className="w-100 p-0">
        <td colSpan="7" className="p-0 w-100">
          <table className="w-100" style={{ background: '#ffffff' }}>
            <tbody>
              <tr
                className={`cursor enGrayBorderBox sd_body_tr ${'td_b_o'}`}
                style={{
                  border: 'none',
                  borderRadius: '5px 0px 0px 5px',
                  borderLeft: `1.0708vw solid #8972DF`,
                }}
              >
                <td
                  style={{ width: '2%' }}
                  className="table-body-left-vertical-badge-td"
                >
                  <div className="f9-500" style={{ letterSpacing: 1 }}>
                    {exp?.subCategory?.title || ''}
                  </div>
                </td>
                <td style={{ width: '20%' }}>
                  <div className="d-flex align-items-center">
                    <div
                      className="text-center d-flex flex-column align-items-center"
                      style={{ width: '20%' }}
                    >
                      <SimpleReactLightbox>
                        <SRLWrapper>
                          <Image
                            src={
                              exp?.photos?.length
                                ? exp?.photos[0]
                                : NOTAVAILABLEIMAGE
                            }
                            alt="View"
                            title="View"
                            fluid
                          />
                        </SRLWrapper>
                      </SimpleReactLightbox>
                    </div>
                    <div className="pl-3">
                      <div className="f14-500">{exp?.name}</div>
                      <div
                        className="f11-500 opacity5 my-1"
                        style={{ wordBreak: 'break-word' }}
                      >
                        #{exp?.expId}
                      </div>
                    </div>
                  </div>
                </td>

                <td
                  style={{ width: '20%' }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="f12-500">
                    {moment(exp.startDate).format('Do MMM YYYY')}
                  </div>
                  <div className="f12-500">
                    {moment(exp.endDate).format('Do MMM YYYY')}
                  </div>
                  <ViewExpSessions exp={exp} />
                </td>
                <td style={{ width: '15%' }}>
                  <div className="f12-400">
                    <div className="f12-400">
                      {exp?.adultPrice > 0 ? `Adult :${exp?.adultPrice}/-` : ''}
                    </div>
                    <div className="f12-400">
                      {!exp?.ageRestriction
                        ? `Kids :${
                            exp?.kidsPrice > 0 ? `${exp?.kidsPrice}/-` : ''
                          }`
                        : null}
                    </div>
                    <div className="f12-400">
                      {exp?.adultPrice <= 0 && exp?.adultPrice <= 0
                        ? getTheLowestPrice(exp?.packages || [])
                        : ''}
                    </div>
                  </div>
                </td>
                <td style={{ width: '15%' }}>
                  <div className="f12-400">
                    {exp?.seatsBooked} | {exp?.seatsLeft}
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="f12-400 mr-1">Status</div>{' '}
                    {!disable && (
                      <Toggle
                        toggleFunction={onToggleChange('ACTIVE')}
                        checked={exp?.active}
                      />
                    )}
                  </div>
                </td>
                <td style={{ width: '15%' }}>
                  <div className="f12-400">
                    {}
                    <ReadMore
                      text={exp.venueAddress}
                      minLength={25}
                      charLength={exp.venueAddress?.length || 10}
                    />
                  </div>
                </td>
                <td
                  style={{ width: '20%' }}
                  className="flexcenter"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="enViewDashboard btn btn-outline-danger"
                    onClick={() =>
                      history.push(
                        `/${
                          exp?.expType === 'SPECIAL'
                            ? 'specialDashboard'
                            : 'curatedDashboard'
                        }/${exp._id}/pending`,
                        { id: exp._id, name: exp.name, expId: exp.expId }
                      )
                    }
                  >
                    <Image
                      src={require('../../../../assets/images/ActionImages/image/onboarding.svg')}
                      alt="View"
                      title="View"
                      fluid
                      className="mr-2"
                    />
                    <div className="f12-500">View Dashboard</div>
                  </button>
                </td>
                <td style={{ width: '20%' }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <ViewExpDetails id={exp._id} />
                    {!disable && (
                      <div
                        className="enIconBtn mr-3"
                        onClick={() => {
                          history.push({
                            pathname: `/${
                              exp?.expType === 'SPECIAL'
                                ? 'editSpecial'
                                : 'editCurated'
                            }/${exp._id}`,
                            state: {
                              editData: {
                                location: {
                                  coordinates: [
                                    exp?.venue?.longitude,
                                    exp?.venue?.latitude,
                                  ],
                                },
                              },
                            },
                          });
                        }}
                      >
                        <Image
                          src={require('../../../../assets/images/UserManagement/pencil.svg')}
                          alt="Edit"
                          title="Edit"
                          fluid
                        />
                      </div>
                    )}
                    <ShareLinkModal
                      userAppLink={exp?.shareLink?.shortLink || ''}
                      webAppLink={`${webappUrl}/restaurant/${onBoarddetails?._id}/experience/${exp?._id}`}
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

export default ExperienceBody;
